import {ToastInterface} from "../types/contexts/ToastContext";
import {AxiosError} from "axios";
import {API} from "../types/API";

export const ErrorHandler = (error: any, url: string, toast: ToastInterface | null, handleError: (error: unknown) => void, setIsForbidden?: (b: boolean) => void) => {
    if (url && url.length > 0)
        API.removeURL(url);
    if (toast && error) {
        let errorTitle = 'Something went wrong'
        if (error instanceof AxiosError) {
            if (error.response?.data.message) {
                errorTitle = error.response?.data.message;
            }
            // @ts-expect-error can be undefined
            if (setIsForbidden && [401, 403].includes(error.response.status)) {
                setIsForbidden(true)
            }
            // @ts-expect-error can be undefined
            if (error.response.status === 440) {
                if (localStorage.getItem('userToken')) {
                    localStorage.removeItem('userToken');
                    localStorage.removeItem('tokenExpiresAt');
                    window.location.replace('/app/admin');
                } else {
                    localStorage.removeItem('brokerToken');
                    window.location.reload();
                }
            }
        }
        toast.show(errorTitle, "bg-red-500");
    } else handleError(error);
}
